class DlBlogArticlesRecY extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.prevBtn = null;
    this.nextBtn = null;
    this._swiperRetries = 0;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.destroySwiper();
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  init() {
    const el = this.querySelector('.dl-blog-articles-rec-y__swiper');
    if (!el) return;

    this.prevBtn = this.querySelector('.dl-blog-articles-rec-y__nav--prev');
    this.nextBtn = this.querySelector('.dl-blog-articles-rec-y__nav--next');

    const slideCount = el.querySelectorAll('.swiper-slide').length;
    if (slideCount <= 1) {
      this.toggleNavDisabled();
      return;
    }

    if (typeof Swiper === 'undefined') {
      this._swiperRetries += 1;
      if (this._swiperRetries < 80) {
        setTimeout(() => this.init(), 100);
      }
      return;
    }
    this._swiperRetries = 0;

    const paginationEl = this.querySelector('.dl-blog-articles-rec-y__pagination');

    this.destroySwiper();

    this.swiper = new Swiper(el, {
      spaceBetween: 8,
      slidesPerView: 1.15,
      centeredSlides: true,
      initialSlide: 0,
      speed: 500,
      watchOverflow: true,
      loop: slideCount >= 4,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : undefined,
      navigation:
        this.prevBtn && this.nextBtn
          ? {
              prevEl: this.prevBtn,
              nextEl: this.nextBtn,
            }
          : undefined,
      breakpoints: {
        750: {
        },
        991: {
          spaceBetween: 20,
          slidesPerView: 2,
          centeredSlides: true,
          initialSlide: 0,
        },
        1600: {
          slidesPerView: 2,
          spaceBetween: 24,
          centeredSlides: true,
          initialSlide: 0,
        },
      },
      on: {
        init: (swiper) => this.syncNavState(swiper),
        slideChange: (swiper) => this.syncNavState(swiper),
        resize: (swiper) => this.syncNavState(swiper),
      },
    });
  }

  syncNavState(swiper) {
    if (!this.prevBtn || !this.nextBtn) return;
    if (swiper.params.loop) {
      this.prevBtn.classList.remove('is-disabled');
      this.nextBtn.classList.remove('is-disabled');
      return;
    }
    this.prevBtn.classList.toggle('is-disabled', swiper.isBeginning);
    this.nextBtn.classList.toggle('is-disabled', swiper.isEnd);
  }

  toggleNavDisabled() {
    if (this.prevBtn) this.prevBtn.classList.add('is-disabled');
    if (this.nextBtn) this.nextBtn.classList.add('is-disabled');
  }
}

if (!customElements.get('dl-blog-articles-rec-y')) {
  customElements.define('dl-blog-articles-rec-y', DlBlogArticlesRecY);
}
